
import { useEffect, useRef } from "react";
import { DivergenceDisplay } from "./DivergenceDisplay";
import { ConvergenceDisplay } from "./ConvergenceDisplay";
import { smoothScrollToElement } from "@/utils/uiUtils";

interface GameOverProps {
  convergenceRound: number | null;
  roundsLength: number;
  user: any;
  onSignInToSave: () => void;
  gameStatus?: string;
  rounds?: Array<{
    proximityScore?: number;
    userWord?: string;
    aiWord?: string;
  }>;
}

export const GameOver = ({
  convergenceRound,
  roundsLength,
  user,
  onSignInToSave,
  gameStatus,
  rounds = []
}: GameOverProps) => {
  const isDiverged = gameStatus === "diverged";
  const gameOverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (gameOverRef.current) {
        smoothScrollToElement("#game-over-container");
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div 
      id="game-over-container"
      ref={gameOverRef}
    >
      {isDiverged ? (
        <DivergenceDisplay 
          user={user} 
          onSignInToSave={onSignInToSave} 
        />
      ) : (
        <ConvergenceDisplay 
          convergenceRound={convergenceRound} 
          rounds={rounds} 
          user={user} 
          onSignInToSave={onSignInToSave}
        />
      )}
    </div>
  );
};
